import { defineMessages } from 'react-intl';

export const messages: {
	permissionDeniedTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	permissionDeniedTooltip: {
		id: 'conversation-assistant-message-actions.studio-trigger-solution-build-plan-card.permission-denied-tooltip',
		defaultMessage: 'You may not have the correct permission to create this solution',
		description:
			'Tooltip message when user does not have permission to build automation or agent or app',
	},
});
